import axios from "axios";
import baseUrl from "../Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Navigate } from "react-router-dom";

/**
 * The branch the user is currently working in — chosen at login and switchable
 * from the header dropdown. Restrictions are set per branch, so this is what
 * decides which limits apply. Empty when nothing is selected, which reads the
 * default settings.
 */
export function activeBranch() {
  const branch = localStorage.getItem("branch");
  return branch === null || branch === "null" ? "" : branch;
}

export async function generategroupid(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/generategroup`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function settinglist() {
    try {
      const header = {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Content-Type": "application/json",
      };
      return await axios
        .post(`${baseUrl}/listsetting`,'', { headers: header })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          catcherror(error);
        });
    } catch (error) {
      catcherror(error);
    }
  }

  export async function settingcreate(data) {
    try {
      const header = {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Content-Type": "application/json",
      };
      return await axios
        .post(`${baseUrl}/createsetting`,data, { headers: header })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          catcherror(error);
        });
    } catch (error) {
      catcherror(error);
    }
  }

// System limits. getrestrictions is also used by the group and loan screens to
// reflect what the backend will allow.
//
// Most limits are set per branch, so pass the branch the screen is working in.
// Callers that just want what applies to the user right now can leave it out
// and get the branch selected in the header (activeBranch below); Settings
// passes an explicit id, including "" to read the default that branches
// without their own settings follow.
export async function getrestrictions(branchId = activeBranch()) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    };
    const query =
      branchId === "" || branchId === null || branchId === undefined
        ? ""
        : `?branch_id=${encodeURIComponent(branchId)}`;
    return await axios
      .get(`${baseUrl}/getrestrictions${query}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function updaterestrictions(data) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/updaterestrictions`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

function catcherror(error) {
  console.log(error);
  if (error.response.status === 401) {
    localStorage.clear();
    window.location.reload();
    <Navigate to={"/login"} />;
  } else if (error.response.status === 422) {
    Swal.fire({
      title:
        "There are few errors occured while inserting/updating the data to the database.",
      showCancelButton: false,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    });
  } else if (error.response.status === 0) {
    toast.error(error.message);
  } else if (error.response.status === 500) {
    toast.error(error.response.statusText);
  } else if (
    error.response.status !== 200 &&
    error.response.data.status === false &&
    error.response.data.code !== 200
  ) {
    toast.error(error.response.data.message);
  } else if (error.request) {
    toast.error(error.request.statusText);
  } else {
    toast.error(error.message);
  }
}
